import { formConstants } from '../../utils/constants/form-constants';
import {
    validateEmail,
    validatePassword,
    validateTitle,
    validateFirstName,
    validateLastName,
    validateAddressLine1,
    validateAddressLine2,
    validateAddressLine3,
    validatePostcode,
    validateMobilePhone,
    validateCity,
    validateCountry,
    validateCounty,
    validateState,
    validateMainAddress,
    validateShippingAddress,
    validateBillingAddress,
    validateBecomeOneClubMember,
    validateFavoritePlayer,
    validateVenues,
    validateChampionship,
    validateChannels,
    validateInterests,
    validateConfirmPassword,
    validateVerificationCode,
    validateOldPassword,
    validateRaMemberId,
    validateCaptchaBox,
    validateMastercard
} from '../../../validators/text-validators';
import { validateDate } from '../../../validators/date-validators';
import { validatePrivacyPolicy, validateOneClubTermsAndServicesPolicy } from '../../../validators/policy-validators';


export const formFieldValidators = {
    [formConstants.emailAddress]: validateEmail,
    [formConstants.oldPassword]: validateOldPassword,
    [formConstants.password]: validatePassword,
    [formConstants.confirmPassword]: validateConfirmPassword,
    [formConstants.title]: validateTitle,
    [formConstants.firstName]: validateFirstName,
    [formConstants.lastName]: validateLastName,
    [formConstants.dateOfBirth]: validateDate,
    [formConstants.addressLine1]: validateAddressLine1,
    [formConstants.addressLine2]: validateAddressLine2,
    [formConstants.addressLine3]: validateAddressLine3,
    [formConstants.postcode]: validatePostcode,
    [formConstants.mobilePhone]: validateMobilePhone,
    [formConstants.city]: validateCity,
    [formConstants.country]: validateCountry,
    [formConstants.county]: validateCounty,
    [formConstants.state]: validateState,
    [formConstants.mainAddress]: validateMainAddress,
    [formConstants.shippingAddress]: validateShippingAddress,
    [formConstants.billingAddress]: validateBillingAddress,
    [formConstants.becomeOneClubMember]: validateBecomeOneClubMember,
    [formConstants.favoritePlayer]: validateFavoritePlayer,
    [formConstants.venues]: validateVenues,
    [formConstants.privacyPolicy]: validatePrivacyPolicy,
    [formConstants.oneClubTermsAndServices]: validateOneClubTermsAndServicesPolicy,
    [formConstants.verificationCode]: validateVerificationCode,
    [formConstants.championshipSection]: validateChampionship,
    [formConstants.channelSection]: validateChannels,
    [formConstants.interestSection]: validateInterests,
    [formConstants.raMemberId]: validateRaMemberId,
    [formConstants.reCaptcha]: validateCaptchaBox,
    [formConstants.mastercard]: validateMastercard
};
